export const ADMIN_PHONE = "13978649503";

interface ContactAdminModalProps {
  isOpen: boolean;
  title?: string;
  description: string;
  phoneLabel?: string;
  onClose: () => void;
}

export default function ContactAdminModal({
  isOpen,
  title = "联系我们",
  description,
  phoneLabel = "服务电话",
  onClose,
}: ContactAdminModalProps) {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-[110] flex items-center justify-center bg-black/40 p-4"
      onClick={onClose}
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="contact-admin-title"
        className="bg-background-50 rounded-xl w-full max-w-md shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="px-5 py-4 border-b border-background-200 flex items-center gap-3">
          <div className="w-9 h-9 rounded-full bg-accent-100 flex items-center justify-center shrink-0">
            <i className="ri-customer-service-2-line text-accent-600 text-lg" />
          </div>
          <h3 id="contact-admin-title" className="text-sm font-semibold text-foreground-900">
            {title}
          </h3>
        </div>

        <div className="px-5 py-4 space-y-3">
          <p className="text-sm text-foreground-600 leading-relaxed">{description}</p>
          <div className="rounded-lg bg-accent-50 border border-accent-200 px-4 py-3 flex items-center gap-3">
            <i className="ri-phone-line text-accent-600 text-lg shrink-0" />
            <div>
              <p className="text-xs text-foreground-500">{phoneLabel}</p>
              <p className="text-base font-semibold text-foreground-900 tracking-wide mt-0.5">
                {ADMIN_PHONE}
              </p>
            </div>
          </div>
          <p className="text-xs text-foreground-400">确认后将唤起拨号，请保持通话畅通。</p>
        </div>

        <div className="px-5 py-4 border-t border-background-200 flex items-center justify-end gap-2">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 rounded-lg border border-background-300 text-foreground-600 text-sm hover:bg-background-100 transition-colors whitespace-nowrap"
          >
            取消
          </button>
          <button
            type="button"
            onClick={() => {
              onClose();
              window.location.href = `tel:${ADMIN_PHONE}`;
            }}
            className="px-4 py-2 rounded-lg bg-accent-500 hover:bg-accent-600 text-background-50 text-sm font-medium transition-colors whitespace-nowrap flex items-center gap-1.5"
          >
            <i className="ri-phone-fill" />
            确认拨打
          </button>
        </div>
      </div>
    </div>
  );
}
